import { normalizeAccountFlags } from "./forcedPasswordChange";

// Any account that already has a role (teacher, admin or student) bypasses
// onboarding, so existing accounts are never interrupted. Brand-new accounts
// with no role must complete it.
export const isOnboardingComplete = (userData) =>
  userData?.onboardingCompleted === true ||
  userData?.role === "teacher" ||
  userData?.role === "admin" ||
  userData?.role === "student";

// The signed-in user as the app's routing sees it, built from a users/{uid}
// profile (or the placeholder used when no profile document exists).
export const buildAccountState = (currentUser, userData) => ({
  ...currentUser,
  ...userData,
  uid: currentUser.uid,
  email: userData.email || currentUser.email || "",
  displayName: userData.displayName || currentUser.displayName || "",
  role: userData.role || null,
  onboardingCompleted: isOnboardingComplete(userData),
  ...normalizeAccountFlags(userData),
});
